import { Box, Tab, Tabs } from "@mui/material";
import { useNavigate } from "react-router-dom";
import React from "react";
import PromotionFeedbackTable from "../../features/manageFeedbackReports/feedbackTable";
import DailyPointsSummaryTable from "../../features/manageFeedbackReports/dailyPointsSummaryTable";
import InactiveUsersReportTable from "../../features/manageFeedbackReports/inactiveUsersReportTable";
import ReportsTopbar from "../../features/manageFeedbackReports/reportsTopbar";
import ReportsRedemptionLogsTable from "../../features/manageFeedbackReports/reportsRedemptionLogsTable";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ManageReviews = () => {
  const navigate = useNavigate();

  const [valueTabs, setValueTabs] = React.useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };
  const [valueTabs1, setValueTabs1] = React.useState(0);
  const handleChangeTabs1 = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs1(newValue);
  };

  return (
    <>
      <div className="main_title">
        <h1>Manage Reviews</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -
          Manage Reviews
        </p>
      </div>

      <div className="cards">
        <CustomTabPanel value={valueTabs} index={0}>
          <PromotionFeedbackTable />
        </CustomTabPanel>
      </div>
    </>
  );
};

export default ManageReviews;
